























/** Отключённая кнопка не даёт событий мыши, а loading в ant её не отключает — клик гасим сами */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MmHintedButton extends Vue {
	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: '' }) readonly disabledReason!: string;

	@Prop({ default: 'default' }) readonly type!: string;

	@Prop({ default: false }) readonly loading!: boolean;

	@Prop({ default: 'default' }) readonly size!: string;

	@Prop({ default: '' }) readonly icon!: string;

	@Prop({ default: 'button' }) readonly htmlType!: string;

	@Prop({ default: false }) readonly block!: boolean;

	/** Класс кнопки приходит пропом: у отключённой кнопки он уехал бы на обёртку подсказки */
	@Prop({ default: '' }) readonly buttonClass!: string;

	@Prop({ default: '' }) readonly ariaLabel!: string;

	@Prop({ default: '' }) readonly hint!: string;

	@Prop({ default: 'top' }) readonly placement!: string;

	/** null — Vue не выводит атрибут: у кнопки с текстом имя берётся из содержимого слота */
	get accessibleName(): string | null {
		return this.ariaLabel !== '' ? this.ariaLabel : null;
	}

	get resolvedHtmlType(): string {
		if (this.loading && this.htmlType === 'submit') {
			return 'button';
		}

		return this.htmlType;
	}

	get tooltipText(): string {
		const reason = this.disabledReason ? String(this.disabledReason).trim() : '';

		if (this.disabled && reason !== '') {
			return reason;
		}

		return this.hint ? String(this.hint).trim() : '';
	}

	mounted(): void {
		this.warnIfUnexplained();
	}

	@Watch('disabled')
	onDisabledChanged(): void {
		this.warnIfUnexplained();
	}

	@Watch('disabledReason')
	onDisabledReasonChanged(): void {
		this.warnIfUnexplained();
	}

	handleClick(event: Event): void {
		if (this.disabled || this.loading) {
			return;
		}

		this.$emit('click', event);
	}

	private warnIfUnexplained(): void {
		if (process.env.NODE_ENV === 'production') {
			return;
		}

		const reason = this.disabledReason ? String(this.disabledReason).trim() : '';

		if (this.disabled && reason === '') {
			// eslint-disable-next-line no-console
			console.warn(
				'[MmHintedButton] Кнопка отключена без объяснения причины. ' +
					'Правило раздела «Мобильный мониторинг»: отключённая кнопка ВСЕГДА объясняет ' +
					'причину подсказкой поверх. Передайте `disabled-reason`.',
			);
		}
	}
}
